// extracted by mini-css-extract-plugin
export var carrierIcon = "_vm-0";
export var carrierLogo = "_vm-1";
export var detailsSection = "_vm-2";